module.exports = [
    'check_circle',
    'content_copy',
    'progress_activity',
    'home',
    'person',
    'mail',
    'redeem',
    'amp_stories',
    'area_chart',
    'share',
    'close',
    'settings',
    'open_in_new',
    'edit',
    'save',
    'shopping_cart',
    'favorite',
    'error',
    'rss_feed',
    'search',
    'lock',
    'lock_open_right',
    // 'ios_share'
].sort();
